require('../modules/es6.parse-int');
module.exports = require('../modules/_core').parseInt;



//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/node_modules/core-js/es6/parse-int.js
// module id = ../../../../core-js/es6/parse-int.js
// module chunks = polyfills